export const useIsCompanionOAuthRedirectEnabled = (path?: string) => {
  const config = useRuntimeConfig();

  if (
    config.public.oauthClient.enableRedirect != true ||
    config.public.oauthClient.oauthAuthUrl == undefined
  ) {
    return false;
  }

  if (path?.startsWith("/companion") == true) {
    return true;
  }

  const hostname = import.meta.server
    ? useRequestURL().hostname
    : window.location.hostname;

  return (
    hostname.startsWith("companion.") ||
    hostname == "iewwritingcompanion.com" ||
    hostname == "staging.iewwritingcompanion.com"
  );
};
